import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshRequest = null;
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const request = error.config;
    const url = request?.url || "";
    if (error.response?.status !== 401 || request?._sessionRetried || url.includes("/auth/")) return Promise.reject(error);
    request._sessionRetried = true;
    try {
      refreshRequest ||= api.post("/auth/refresh").finally(() => { refreshRequest = null; });
      await refreshRequest;
      return api(request);
    } catch (refreshError) {
      return Promise.reject(refreshError);
    }
  }
);

export function formatError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function stableMediaUrl(url) {
  const match = String(url || "").match(/(\/api\/public\/media\/[0-9a-f-]{36})(?:[/?#]|$)/i);
  return match ? match[1] : url;
}
